import { useMemo } from 'react';
import { OrderCartProductItem } from '../OrderCartProductItem/OrderCartProductItem';
import { PRODUCT_TYPE } from 'src/types/product';
import { IMenuProduct } from 'src/types/products';
import { IResponseComboItem } from '~/types/combo';
import { productUtils } from '~/utils/productUtils';

interface IProps {
  product: IMenuProduct;
}

export const OrderCartProductItems: React.FC<IProps> = (props: IProps): JSX.Element | null => {
  const isMeal = useMemo((): boolean => props.product.type === PRODUCT_TYPE.MEAL_COMBO, [props.product.type]);

  const items = useMemo((): IResponseComboItem[] => {
    if (isMeal) {
      return productUtils.getDefiniteSizeSelectedItems(props.product.items || [], props.product.size);
    }

    // deal combo items
    return props.product.items || [];
  }, [isMeal, props.product.size, props.product.items]);

  if (!items.length) return null;

  return (
    <div>
      {items.map((item, index) => (
        <OrderCartProductItem key={productUtils.getMealItemKey(item, index)} item={item} isMeal={isMeal} />
      ))}
    </div>
  );
};
